export const TIMELINE_RULER_TICK_WIDTH_PX = 100;

export const TIMELINE_MIN_DURATION = 30;

export interface FontSource {
    family: string;
    cssUrl: string;
}

export const CANVAS_ID = "rendley";

export const COMPOSITION_CONTAINER_ID = "composition";

export declare enum PropertyDescriptionTypeEnum {
    NUMBER = "number",
    NUMBER_ARRAY = "numberArray",
    VECTOR2 = "vector2",
    VECTOR2_ARRAY = "vector2Array",
    VECTOR3 = "vector3",
    VECTOR3_ARRAY = "vector3Array",
    VECTOR4 = "vector4",
    VECTOR4_ARRAY = "vector4Array",
    RGB = "rgb",
    RGB_ARRAY = "rgbArray",
    RGBA = "rgba",
    RGBA_ARRAY = "rgbaArray",
    MATRIX2 = "matrix2",
    MATRIX2_ARRAY = "matrix2Array",
    MATRIX3 = "matrix3",
    MATRIX3_ARRAY = "matrix3Array",
    MATRIX4 = "matrix4",
    MATRIX4_ARRAY = "matrix4Array",
    STRING = "string",
    STRING_ARRAY = "stringArray",
    BOOLEAN = "boolean",
    BOOLEAN_ARRAY = "booleanArray",
    OTHER = "other",
    OTHER_ARRAY = "otherArray"
}

export interface PropertyDescription {
    name: string;
    type: PropertyDescriptionTypeEnum;
    label?: string;
    description?: string;
    defaultValue: any;
    initOnly?: boolean;
}

export interface TransitionDescription {
    id: string;
    label: string;
    thumbnailUrl: string;
    videoPreviewUrl: string;
    shaderUrl: string;
    properties: PropertyDescription[];
}

export interface FilterDescription {
    id: string;
    label: string;
    thumbnailUrl: string;
    lutUrl: string;
}

export interface TitleDescription {
    id: string;
    name: string;
    thumbnailUrl: string;
    videoPreviewUrl: string;
    propertiesUrl: string;
    dataUrl: string;
    duration: number;
}

export interface EffectDescription {
    id: string;
    label: string;
    thumbnailUrl: string;
    videoPreviewUrl: string;
    shaderUrl: string;
    properties: PropertyDescription[];
}